export default __webpack_public_path__ + "google-plus-symbol.png";